import { Routes, Route } from 'react-router-dom'
import { AuthProvider } from './hooks/useAuth'
import { Layout } from './components/Layout'
import { ProtectedRoute } from './components/ProtectedRoute'
import { AdminProtectedRoute } from './components/AdminProtectedRoute'
import { ToastProvider } from './components/ui/Toast'
import { TenantSettingsProvider } from './hooks/useTenantSettings'

// Pages
import { LandingPage } from './pages/LandingPage'
import { LoginPage } from './pages/LoginPage'
import { RegisterPage } from './pages/RegisterPage'
import { DashboardPage } from './pages/DashboardPage'
import { CustomersPage } from './pages/CustomersPage'
import { BookingsPage } from './pages/BookingsPage'
import CalendarPage from './pages/CalendarPage'
import { StaffPage } from './pages/StaffPage'
import { RoomsPage } from './pages/RoomsPage'
import { ReportsPage } from './pages/ReportsPage'
import { NotFoundPage } from './pages/NotFoundPage'
import { SettingsPage } from './pages/SettingsPage'
import { ProfilePage } from './pages/ProfilePage'
// Customer Portal (public)
import PortalLoginPage from './pages/PortalLoginPage'
import PortalBookingsPage from './pages/PortalBookingsPage'
import PortalLoyaltyPage from './pages/PortalLoyaltyPage'
import PortalQrPage from './pages/PortalQrPage'
// Staff utility
import StaffCheckinPage from './pages/StaffCheckinPage'
// Admin pages
import { AdminLoginPage } from './pages/admin/AdminLoginPage'
import { AdminLayout } from './components/admin/AdminLayout'
import { AdminDashboardPage } from './pages/admin/AdminDashboardPage'
import { AdminTenantsPage } from './pages/admin/AdminTenantsPage'
import { AdminUsersPage } from './pages/admin/AdminUsersPage'
import { AdminReportsPage } from './pages/admin/AdminReportsPage'
import { AdminAnnouncementsPage } from './pages/admin/AdminAnnouncementsPage'
import { AdminSettingsPage } from './pages/admin/AdminSettingsPage'

function App() {
  return (
    <AuthProvider>
      <TenantSettingsProvider>
      <ToastProvider>
        <Routes>
        {/* Public routes */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/signup" element={<RegisterPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
  {/* Customer portal public routes */}
  <Route path="/portal/login" element={<PortalLoginPage />} />
  <Route path="/portal/bookings" element={<PortalBookingsPage />} />
  <Route path="/portal/loyalty" element={<PortalLoyaltyPage />} />
  <Route path="/portal/qr" element={<PortalQrPage />} />

        {/* Admin routes */}
        <Route path="/admin/login" element={<AdminLoginPage />} />
        <Route element={<AdminProtectedRoute><AdminLayout /></AdminProtectedRoute>}>
          <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
          <Route path="/admin/tenants" element={<AdminTenantsPage />} />
          <Route path="/admin/users" element={<AdminUsersPage />} />
          <Route path="/admin/reports" element={<AdminReportsPage />} />
          <Route path="/admin/announcements" element={<AdminAnnouncementsPage />} />
          <Route path="/admin/settings" element={<AdminSettingsPage />} />
        </Route>

        {/* Protected routes */}
        <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/app" element={<DashboardPage />} />
          <Route path="/customers" element={<CustomersPage />} />
          <Route path="/bookings" element={<BookingsPage />} />
          <Route path="/calendar" element={<CalendarPage />} />
          <Route path="/rooms" element={<RoomsPage />} />
          <Route path="/staff" element={<StaffPage />} />
          <Route path="/reports" element={<ReportsPage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/staff/checkin" element={<StaffCheckinPage />} />
        </Route>

        {/* 404 fallback */}
        <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </ToastProvider>
      </TenantSettingsProvider>
    </AuthProvider>
  )
}

export default App